import ReceiveItemsProductListPanel from "./receiveItemsProductListPanel.container";
export default ReceiveItemsProductListPanel;
